var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
      _c("div", { staticClass: "d-flex justify-content-start" }, [
        _c("div", { staticClass: "p-1" }, [
          _c("img", {
            staticClass: "round",
            attrs: {
              src:
                _vm.member.avatar !== null
                  ? _vm.member.avatar.url
                  : "/images/avatar.png",
              alt: "avatar",
              height: "40",
              width: "40",
            },
          }),
          _vm._v(" "),
          _vm.contactStatus === true
            ? _c(
                "div",
                {
                  staticClass: "badge badge-pill badge-success",
                  staticStyle: {
                    border: "none",
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    "padding-right": "0.4em",
                    "padding-left": "0.4em",
                  },
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: "Already a contact",
                  },
                },
                [_c("i", { staticClass: "feather icon-check" })]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pl-0 pt-1 pr-1 pb-1" },
          [
            _c(
              "a",
              {
                staticClass: "text-bold-600",
                staticStyle: { color: "inherit" },
                attrs: { href: "/member/profiles/" + _vm.member.username },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.member.first_name) +
                    " " +
                    _vm._s(_vm.member.last_name) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.member.badges, function (badge) {
              return _c("span", [
                _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "15px" },
                  attrs: {
                    src: badge.image,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: badge.name,
                    alt: "badge image",
                  },
                }),
              ])
            }),
            _vm._v(" "),
            _vm.member.user_badge_name !== null &&
            _vm.member.user_badge_icon !== null
              ? _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "15px" },
                  attrs: {
                    src: _vm.member.user_badge_image.url,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.member.user_badge_name,
                    alt: "badge image",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "font-small-2 text-muted" }, [
              _vm._v(
                _vm._s(_vm.member.position) +
                  " " +
                  _vm._s(
                    _vm.member.organisation !== null
                      ? "at " + _vm.member.organisation
                      : ""
                  )
              ),
            ]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.member.id !== _vm.user_id
        ? _c("div", { staticClass: "p-1 ml-auto" }, [
            _vm.contactStatus === false
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-success waves-effect waves-light btn-sm",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.follow()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.follow")))]
                )
              : _vm.contactStatus === true
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-danger waves-effect waves-light btn-sm",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.unfollow()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.unfollow")))]
                )
              : _vm.contactStatus === "pendingRequest"
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary waves-effect waves-light btn-sm",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.cancelPending()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.pending")))]
                )
              : _vm.contactStatus === "pendingAccept"
              ? _c("div", { staticClass: "d-flex flex-row" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.acceptRequest()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.__("globals.accept")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger btn-sm ml-05",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.declineRequest()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.__("globals.decline")))]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }